<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="#292929" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <rect x="12" y="8" width="0.01" height="0.01" stroke="#292929" stroke-width="3" stroke-linejoin="round"/>
    <path d="M12 12V16" stroke="#292929" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
